import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Dropdown from '../../../../../components/Dropdown';

import '../../styles.css';

const DropdownWithTitle = (props) => (
  <div styleName="field-dropdown">
    <label styleName="menu-field-label" htmlFor={props.inputId}>
      <FormattedMessage {...props.title} />
    </label>
    <Dropdown
      data-cy={props['data-cy']}
      placeholder={props.placeholder}
      id={props.inputId}
      selection
      options={props.options}
      value={props.value}
      onChange={props.onChange}
    />
  </div>
);

DropdownWithTitle.propTypes = {
  'inputId': PropTypes.string,
  'title': PropTypes.object,
  'placeholder': PropTypes.string,
  'options': PropTypes.array,
  'value': PropTypes.string,
  'onChange': PropTypes.func,
  'data-cy': PropTypes.string,
};

export default DropdownWithTitle;
